export default __webpack_public_path__ + "static/media/embarazada.07b44c11.png";